(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[526],{

/***/ 26985:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/raffles",
      function () {
        return __webpack_require__(46945);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Alert; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

/* This example requires Tailwind CSS v2.0+ */ 
function Alert(param) {
    var children = param.children, type = param.type;
    var colors = {
        bg: "bg-green-50",
        text: "text-green-800"
    };
    if (type === "danger") {
        colors = {
            bg: "bg-red-50",
            text: "text-red-800"
        };
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "p-4 rounded-md ".concat(colors.bg),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-sm font-medium ".concat(colors.text),
                children: children
            })
        })
    });
};


/***/ }),

/***/ 52077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Spinner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16746);




function Button(param) {
    var children = param.children, _type = param.type, type = _type === void 0 ? "button" : _type, onClick = param.onClick, href = param.href, target = param.target, loading = param.loading, disabled = param.disabled, _theme = param.theme, theme = _theme === void 0 ? "primary" : _theme, className = param.className, link = param.link;
    var themeClasses = "text-gray-800 text-bg bg-theme-1 border-theme-1 hover:bg-transparent hover:border-theme-1 transition duration-300 hover:text-theme-1";
    if (theme === "outline") {
        themeClasses = "text-theme-1 border-theme-1 hover:text-gray-800 text-theme-1 hover:bg-theme-1 hover:text-white";
    }
    if (theme === "link") {
        themeClasses = "border-transparent text-theme-1 hover:text-theme-1";
    }
    if (disabled) {
        themeClasses = "opacity-50 cursor-not-allowed";
    }
    var classes = "inline-flex items-center px-4 py-2 border-2 text-sm font-bold rounded-md transition-all duration-200 tracking-wide text-center justify-center ".concat(themeClasses, " ").concat(className);
    if (link && href) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: href,
            target: target,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                className: classes,
                children: children
            })
        });
    }
    if (href) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: href,
            target: target,
            className: classes,
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: type,
        disabled: disabled,
        onClick: onClick,
        className: classes,
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Spinner__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            dimensionClasses: "w-5 h-5"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: children
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 1401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Countdown; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./hooks/useCountdown.js

var useCountdown = function(targetDate) {
    var countDownDate = new Date(targetDate).getTime();
    var ref = (0,react.useState)(countDownDate - new Date().getTime()), countDown = ref[0], setCountDown = ref[1];
    (0,react.useEffect)(function() {
        var interval = setInterval(function() {
            setCountDown(countDownDate - new Date().getTime());
        }, 1000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        countDownDate
    ]);
    return getReturnValues(countDown);
};
var getReturnValues = function(countDown) {
    var days = Math.floor(countDown / (1000 * 60 * 60 * 24));
    var hours = Math.floor(countDown % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    var minutes = Math.floor(countDown % (1000 * 60 * 60) / (1000 * 60));
    var seconds = Math.floor(countDown % (1000 * 60) / 1000);
    return [
        days,
        hours,
        minutes,
        seconds
    ];
};


;// CONCATENATED MODULE: ./components/Countdown.js




var DateTimeDisplay = function(param) {
    var value = param.value, type = param.type, isDanger = param.isDanger;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-[32px] md:text-[52px] lg:text-[96px] font-bold text-white leading-[58px] lg:leading-[105px] mb-2 w-[75px] md:w-[125px] lg:w-[175px]",
                children: value
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "md:text-[24px] lg:text-[32px]",
                children: type
            })
        ]
    });
};
function Countdown(param) {
    var date = param.date, _simple = param.simple, simple = _simple === void 0 ? false : _simple;
    var ref = (0,_sliced_to_array/* default */.Z)(useCountdown(date), 4), days = ref[0], hours = ref[1], minutes = ref[2], seconds = ref[3];
    if (simple) {
        if (days > 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    days,
                    " days ",
                    hours,
                    " hrs ",
                    minutes,
                    " mins ",
                    seconds,
                    " s"
                ]
            });
        } else if (hours > 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    hours,
                    " hrs ",
                    minutes,
                    " mins ",
                    seconds,
                    " s"
                ]
            });
        } else if (minutes > 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    minutes,
                    " mins ",
                    seconds,
                    " s"
                ]
            });
        } else if (seconds > 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    seconds,
                    " s"
                ]
            });
        }
        return "";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col items-center justify-center text-center mt-[100px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex space-x-5 lg:space-x-20",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateTimeDisplay, {
                    value: days,
                    type: "Days",
                    isDanger: days <= 3
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateTimeDisplay, {
                    value: hours,
                    type: "Hours"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateTimeDisplay, {
                    value: minutes,
                    type: "Mins"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateTimeDisplay, {
                    value: seconds,
                    type: "Seconds"
                })
            ]
        })
    });
}
/* harmony default export */ var components_Countdown = (Countdown);


/***/ }),

/***/ 47031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2369);



function PageHeader(param) {
    var heading = param.heading, description = param.description, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "max-w-2xl mx-auto mt-5 mb-10",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "space-y-4 text-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "text-3xl font-extrabold tracking-tight text-neutral-200 sm:text-5xl md:text-6xl",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "block xl:inline",
                            children: heading
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mx-auto space-y-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-base text-neutral-500 md:text-xl",
                                children: description
                            }),
                            children
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PageHeader);


/***/ }),

/***/ 61453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RaffleInfo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31838);


/* This example requires Tailwind CSS v2.0+ */ var faqs = [
    {
        id: 1,
        question: "How much ".concat("BRTC", " does a raffle ticket cost?"),
        answer: "Each raffle has its own 'Ticket cost'. Check the raffle you like for the corresponding ticket cost."
    },
    {
        id: 2,
        question: "How many raffle tickets can I buy for each raffle?",
        answer: "You can buy as many tickets as your ".concat("BRTC", " balance will allow. The more tickets you buy, the higher your odds of winning.")
    },
    {
        id: 3,
        question: "When buying a raffle ticket, what are the 2 parts of the transaction?",
        answer: "The first part of the transaction sends ".concat("BRTC", " back to the creator wallet. The second part of the transaction opts you in to the prize.")
    },
    {
        id: 4,
        question: "What happens when the raffle's timer runs out?",
        answer: "An address will be randomly selected from all of the entries and the prize will be automatically sent to the winning wallet."
    }, 
];
function RaffleInfo() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "mt-12 md:mt-36",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "max-w-6xl mx-auto",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "bg-gray-800 rounded-lg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "px-4 py-16 mx-auto max-w-7xl sm:py-24 sm:px-6 lg:px-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                            className: "text-3xl font-extrabold text-gray-50",
                            children: [
                                "How do ",
                                _config__WEBPACK_IMPORTED_MODULE_1__/* ["default"].siteName */ .Z.siteName,
                                " Raffles work?"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "pt-10 mt-6 border-t border-gray-300 border-opacity-25",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dl", {
                                className: "space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-12",
                                children: faqs.map(function(faq) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                                                className: "text-lg font-medium leading-6 text-gray-50",
                                                children: faq.question
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", {
                                                className: "mt-2 text-base text-gray-400",
                                                children: faq.answer
                                            })
                                        ]
                                    }, faq.id);
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};


/***/ }),

/***/ 16746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Spinner(param) {
    var _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? 4 : _strokeWidth, _dimensionClasses = param.dimensionClasses, dimensionClasses = _dimensionClasses === void 0 ? "w-16 h-16" : _dimensionClasses;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            className: "".concat(dimensionClasses, " text-white animate-spin"),
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    className: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    strokeWidth: strokeWidth
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);


/***/ }),

/***/ 76008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);




function useNfd() {
    var getNfd = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(address) {
            var data;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return axios__WEBPACK_IMPORTED_MODULE_2___default().get("https://api.nf.domains/nfd/address?address=".concat(address, "&limit=1&view=full"));
                    case 3:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function getNfd(address) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        getNfd: getNfd
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useNfd);


/***/ }),

/***/ 46945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ raffles; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./config.js
var config = __webpack_require__(31838);
// EXTERNAL MODULE: ./components/RaffleInfo.js
var RaffleInfo = __webpack_require__(61453);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 172 modules
var motion = __webpack_require__(50924);
// EXTERNAL MODULE: ./hooks/useAlgo.js
var useAlgo = __webpack_require__(39246);
// EXTERNAL MODULE: ./components/Alert.js
var Alert = __webpack_require__(34950);
// EXTERNAL MODULE: ./hooks/useRaffles.js
var useRaffles = __webpack_require__(33217);
// EXTERNAL MODULE: ./components/Spinner.js
var Spinner = __webpack_require__(16746);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/party-js/lib/index.js
var lib = __webpack_require__(94393);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/ExternalLinkIcon.js
var ExternalLinkIcon = __webpack_require__(84563);
// EXTERNAL MODULE: ./components/Countdown.js + 1 modules
var Countdown = __webpack_require__(1401);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
// EXTERNAL MODULE: ./utils/formatNumber.js
var formatNumber = __webpack_require__(94511);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./hooks/useNfd.js
var useNfd = __webpack_require__(76008);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/RafflePreview.js

















function Detail(param) {
    var label = param.label, value = param.value, children = param.children, success = param.success;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-sm font-bold text-text opacity-60",
                children: label
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,clsx_m/* default */.Z)(" text-lg font-bold", success ? "text-green-500" : "text-text"),
                children: children || value
            })
        ]
    });
}
function RafflePreview(param) {
    var raffle = param.raffle;
    var id = raffle.id, assetId = raffle.assetId, endDate = raffle.endDate;
    var ref = (0,useAlgo/* useAlgo */.t1)(), address = ref.address, sendTokensToTokenWalletAndOptIn = ref.sendTokensToTokenWalletAndOptIn;
    var ref1 = (0,useRaffles/* useRaffles */.Z)(), joinRaffle = ref1.joinRaffle, getEntries = ref1.getEntries, setBalance = ref1.setBalance, balance = ref1.balance;
    var ref2 = (0,react.useState)(0), numberOfTickets = ref2[0], setNumberOfTickets = ref2[1];
    var ref3 = (0,react.useState)([]), entries = ref3[0], setEntries = ref3[1];
    var ref4 = (0,react.useState)(null), error = ref4[0], setError = ref4[1];
    var ref5 = (0,react.useState)(null), success = ref5[0], setSuccess = ref5[1];
    var ref6 = (0,react.useState)(false), loading = ref6[0], setLoading = ref6[1];
    var ref7 = (0,react.useState)(false), setEntriesLoading = ref7[0], setSetEntriesLoading = ref7[1];
    var getNfd = (0,useNfd/* default */.Z)().getNfd;
    var ref8 = (0,react.useState)(null), winner = ref8[0], setWinner = ref8[1];
    var formattedEntries = entries === null || entries === void 0 ? void 0 : entries.map(function(entry) {
        return {
            sender: entry.transaction.sender,
            amount: entry.tickets
        };
    }).reduce(function(acc, curr) {
        var sender = curr.sender, amount = curr.amount;
        if (!acc[sender]) {
            acc[sender] = 0;
        }
        acc[sender] += amount;
        return acc;
    }, {});
    // sort formattedEntries by value
    var sortedEntries = Object.keys(formattedEntries).map(function(key) {
        return {
            address: key,
            amount: formattedEntries[key]
        };
    }).sort(function(a, b) {
        return b.amount - a.amount;
    });
    var numberOfEntries = sortedEntries.reduce(function(acc, curr) {
        return acc + curr.amount;
    }, 0);
    var numberOfYourEntries = sortedEntries.reduce(function(acc, curr) {
        return acc + (curr.address === address ? curr.amount : 0);
    }, 0);
    var confettiRef = (0,react.useRef)(null);
    // check that date is not in the past
    var now = new Date();
    var raffleDate = new Date(endDate);
    var raffleIsOver = raffleDate < now;
    var enterRaffle = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var txn, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSuccess(false);
                        if (!(!numberOfTickets || numberOfTickets === 0)) {
                            _ctx.next = 4;
                            break;
                        }
                        setError("You must enter at least 1 ticket");
                        return _ctx.abrupt("return");
                    case 4:
                        _ctx.prev = 4;
                        setError(null);
                        setLoading(true);
                        _ctx.next = 9;
                        return sendTokensToTokenWalletAndOptIn(assetId, numberOfTickets * raffle.ticketCost);
                    case 9:
                        txn = _ctx.sent;
                        _ctx.next = 12;
                        return joinRaffle(txn, id, address, numberOfTickets);
                    case 12:
                        setBalance(balance - numberOfTickets * raffle.ticketCost);
                        setSuccess(numberOfTickets);
                        setNumberOfTickets(0);
                        lib_default().confetti(confettiRef.current, {
                            count: lib_default().variation.range(20, 60)
                        });
                        lib_default().confetti(confettiRef.current, {
                            count: lib_default().variation.range(20, 60)
                        });
                        lib_default().confetti(confettiRef.current, {
                            count: lib_default().variation.range(20, 60)
                        });
                        _ctx.next = 26;
                        break;
                    case 20:
                        _ctx.prev = 20;
                        _ctx.t0 = _ctx["catch"](4);
                        console.error(_ctx.t0);
                        ;
                        setError((ref = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message) !== null && ref !== void 0 ? ref : "Unexpected error occurred");
                        setSuccess(false);
                    case 26:
                        _ctx.prev = 26;
                        setLoading(false);
                        return _ctx.finish(26);
                    case 29:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    20,
                    26,
                    29
                ]
            ]);
        }));
        return function enterRaffle() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!raffle.winner) return;
        (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, nfd;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        _ctx.next = 4;
                        return getNfd(raffle.winner);
                    case 4:
                        nfd = _ctx.sent;
                        if (!(nfd && nfd.length > 0)) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return", setWinner(get_default()(nfd, "[0].name")));
                    case 7:
                        setWinner("".concat((ref = raffle.winner) === null || ref === void 0 ? void 0 : ref.slice(0, 4), "...").concat((ref1 = raffle.winner) === null || ref1 === void 0 ? void 0 : ref1.slice(-4)));
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }))();
    }, [
        raffle.winner
    ]);
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var them;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setSetEntriesLoading(true);
                        _ctx.next = 4;
                        return getEntries(id);
                    case 4:
                        them = _ctx.sent;
                        setEntries(them);
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                    case 11:
                        _ctx.prev = 11;
                        setSetEntriesLoading(false);
                        return _ctx.finish(11);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8,
                    11,
                    14
                ]
            ]);
        }))();
    }, [
        address
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex items-center justify-center w-full overflow-hidden bg-gray-800 rounded-t-md aspect-square",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/raffles/".concat(raffle.id),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.img */.E.img, {
                                src: raffle.image,
                                alt: raffle.name,
                                className: "absolute inset-0 z-10 object-cover rounded-t-md"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                        dimensionClasses: "w-8 h-8"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative col-span-12 md:col-span-6 lg:col-span-7",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative px-3 py-4 text-gray-200 bg-gray-800 rounded-b-md",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col space-y-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "mb-1 text-sm font-bold text-text opacity-60",
                                            children: raffle.collection
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                            className: "flex items-center mb-1 space-x-3 text-lg font-bold",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: raffle.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "https://www.nftexplorer.app/asset/".concat(raffle.assetId),
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "w-6 opacity-50 text-text",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExternalLinkIcon/* default */.Z, {})
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "grid grid-cols-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Detail, {
                                            label: "Ticket cost",
                                            value: "".concat(raffle.ticketCost, " ").concat("BRTC")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Detail, {
                                            label: "Total Entries",
                                            value: (0,formatNumber/* default */.Z)(numberOfEntries) || 0
                                        }),
                                        address && /*#__PURE__*/ (0,jsx_runtime.jsx)(Detail, {
                                            label: "My Entries",
                                            value: numberOfYourEntries || 0
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "grid ".concat(winner ? "grid-cols-2" : "grid-cols-1"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-sm font-bold text-text opacity-60",
                                                    children: "Ends in"
                                                }),
                                                new Date(raffle.endDate) < new Date() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "font-bold text-green-500",
                                                    children: "Raffle has ended"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "font-bold",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Countdown/* default */.Z, {
                                                        date: raffle.endDate,
                                                        simple: true
                                                    })
                                                })
                                            ]
                                        }),
                                        winner && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Detail, {
                                                label: "Winner",
                                                value: winner,
                                                success: true
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "w-full !flex",
                            href: "/raffles/".concat(raffle.id),
                            link: true,
                            children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                dimensionClasses: "w-4 h-4"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "View Raffle"
                            })
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var components_RafflePreview = (RafflePreview);

;// CONCATENATED MODULE: ./components/RaffleList.js










function RaffleList(param) {
    var raffles = param.raffles;
    var address = (0,useAlgo/* useAlgo */.t1)().address;
    var sortedRaffles = (0,_to_consumable_array/* default */.Z)(raffles).sort(function(a, b) {
        var aTime = new Date(a.endDate).getTime();
        var bTime = new Date(b.endDate).getTime();
        return aTime - bTime;
    }).sort(function(a, b) {
        // sort winners to bottom
        if (a.winner && !b.winner) {
            return 1;
        }
        if (!a.winner && b.winner) {
            return -1;
        }
        return 0;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mx-auto space-y-10 max-w-[90rem] px-6",
            children: (sortedRaffles === null || sortedRaffles === void 0 ? void 0 : sortedRaffles.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid w-full grid-cols-1 gap-10 md:grid-cols-2 ".concat(sortedRaffles.length === 1 ? "lg:grid-cols-1 max-w-md mx-auto" : sortedRaffles.length === 2 ? "lg:grid-cols-2 max-w-3xl mx-auto" : "lg:grid-cols-4"),
                children: sortedRaffles.map(function(raffle, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RafflePreview, {
                            raffle: raffle
                        })
                    }, raffle === null || raffle === void 0 ? void 0 : raffle.id);
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-md col-span-1 col-start-2 mx-auto space-y-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                        type: "danger",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "No active raffles found"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-[24px] text-center max-w-sm mx-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: config/* default.discord */.Z.discord,
                                target: "_blank",
                                rel: "noreferrer",
                                className: "font-bold text-theme-1",
                                children: "Join Discord"
                            }),
                            " ",
                            "for more information on the next one!"
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var components_RaffleList = (RaffleList);

// EXTERNAL MODULE: ./components/PageHeader.js
var PageHeader = __webpack_require__(47031);
;// CONCATENATED MODULE: ./pages/raffles/index.js



// config

// components



function RafflesPage(param) {
    var raffles = param.raffles;
    var description = "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "Raffles - ".concat(config/* default.siteName */.Z.siteName),
                description: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                heading: "Raffles",
                description: "Spend ".concat("BRTC", " on raffle tickets to win prizes")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RaffleList, {
                raffles: raffles
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RaffleInfo/* default */.Z, {})
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var raffles = (RafflesPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [924,807,774,888,179], function() { return __webpack_exec__(26985); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);